import { render, staticRenderFns } from "./DocumentsEndorsement.vue?vue&type=template&id=7cf9fa52&scoped=true&"
import script from "./DocumentsEndorsement.vue?vue&type=script&lang=js&"
export * from "./DocumentsEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsEndorsement.vue?vue&type=style&index=0&id=7cf9fa52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9fa52",
  null
  
)

export default component.exports